import { createBrowserRouter } from 'react-router-dom';
import Main from '../../layout/Main';
import AddService from '../../Pages/AddService/AddService';
import Blogs from '../../Pages/Blogs/Blogs';
import ErrorPage from '../../Pages/ErrorPage/ErrorPage';
import Home from '../../Pages/Home/Home/Home';
import Login from '../../Pages/Login/Login';
import MyReview from '../../Pages/MyReview/MyReview';
import DetailsService from '../../Pages/Services/DetailsService/DetailsService';
import Services from '../../Pages/Services/Services/Services';
import SignUp from '../../Pages/SignUp/SignUp';
import PrivateRoute from '../PrivateRoute/PrivateRoute';

const router = createBrowserRouter([
    {
        path : '/',
        element : <Main></Main>,
        errorElement : <ErrorPage></ErrorPage>,
        children : [
            {
                path : '/',
                element : <Home></Home>
            },
            {
                path : '/login',
                element : <Login></Login>
            },
            {
                path : '/signup',
                element : <SignUp></SignUp>
            },
            {
                path : '/services',
                element : <Services></Services>
            },
            {
                path : '/blogs',
                element : <Blogs></Blogs>
            },
            {
                path : '/service/:id',
                loader : ({params})=>fetch(`https://assignment-11-server-sooty.vercel.app/service/${params.id}`),
                element : <DetailsService></DetailsService>
            },
            {
                path : '/myreview',
                element: <PrivateRoute><MyReview></MyReview></PrivateRoute>
            },
            {
                path : '/addservice',
                element: <PrivateRoute><AddService></AddService></PrivateRoute>
            },
        ]
    }
])

export default router;